import React from 'react'
import { InstallType, useIsEligibleForInstall } from '../../../../lib/hooks/install-eligibility'
import { ButtonCtaProps } from '../../../ui-lib/button'
import { LlamaDownloadButtonBase, LlamaUnsupportedOSButton } from './base'

export type WindowsDownloadButtonProps = Omit<ButtonCtaProps, 'onClick'>

export const WindowsDownloadButton: React.FC<WindowsDownloadButtonProps> = (props) => {
  const isEligible = useIsEligibleForInstall(InstallType.Windows)

  return isEligible ? <LlamaDownloadButtonBase {...props} /> : <LlamaUnsupportedOSButton {...props} />
}
